import { IndividualTreasuryItemActions } from 'constants/ActionsTypesTs'
import { IResponseErrorApi } from 'models/CommonInterface'
import {
	IConfirmTreasuryItemProductAction,
	IConfirmTreasuryItemProductPayload,
	IConfirmTreasuryItemProductSuccessAction,
	IGetTreasuryProductDataAction,
	IGetTreasuryProductDataErrorAction,
	IGetTreasuryProductDataParams,
	IGetTreasuryProductDataResponse,
	IGetTreasuryProductDataSuccessAction,
	ILoadingTreasuryItemAction,
	ILoadingTreasuryItemParams,
	ILoadingTreasuryItemResponse,
	ILoadingTreasuryItemSuccessAction,
	IUpdateTreasuryProductDataAction,
	IUpdateTreasuryProductDataErrorAction,
	IUpdateTreasuryProductDataParams,
	IUpdateTreasuryProductDataResponse,
	IUpdateTreasuryProductDataSuccessAction
} from 'models/IndividualTreasuryItem'
import { IResponseResult } from 'models/ResultsInterface'

export const loadingTreasuryItem = (
	payload: ILoadingTreasuryItemParams
): ILoadingTreasuryItemAction => ({
	payload,
	type: IndividualTreasuryItemActions.LOADING_TREASURY_ITEM
})

export const loadingTreasuryItemSuccess = (
	payload: ILoadingTreasuryItemResponse
): ILoadingTreasuryItemSuccessAction => ({
	payload,
	type: IndividualTreasuryItemActions.LOADING_TREASURY_ITEM_SUCCESS
})

export const getTreasuryProductData = (
	payload: IGetTreasuryProductDataParams
): IGetTreasuryProductDataAction => ({
	type: IndividualTreasuryItemActions.GET_TREASURY_PRODUCT_DATA,
	payload
})

export const getTreasuryProductDataSuccess = (
	payload: IGetTreasuryProductDataResponse
): IGetTreasuryProductDataSuccessAction => ({
	type: IndividualTreasuryItemActions.GET_TREASURY_PRODUCT_DATA_SUCCESS,
	payload
})

export const getTreasuryProductDataErrorAction = (
	payload: IResponseErrorApi
): IGetTreasuryProductDataErrorAction => ({
	payload,
	type: IndividualTreasuryItemActions.GET_TREASURY_PRODUCT_DATA_ERROR
})

export const updateTreasuryProductData = (
	payload: IUpdateTreasuryProductDataParams
): IUpdateTreasuryProductDataAction => ({
	type: IndividualTreasuryItemActions.UPDATE_TREASURY_PRODUCT_DATA,
	payload
})

export const updateTreasuryProductDataSuccess = (
	payload: IUpdateTreasuryProductDataResponse
): IUpdateTreasuryProductDataSuccessAction => ({
	type: IndividualTreasuryItemActions.UPDATE_TREASURY_PRODUCT_DATA_SUCCESS,
	payload
})

export const updateTreasuryProductDataErrorAction = (
	payload: IResponseErrorApi
): IUpdateTreasuryProductDataErrorAction => ({
	payload,
	type: IndividualTreasuryItemActions.UPDATE_TREASURY_PRODUCT_DATA_ERROR
})

export const confirmTreasuryItemProduct = (
	payload: IConfirmTreasuryItemProductPayload
): IConfirmTreasuryItemProductAction => ({
	type: IndividualTreasuryItemActions.CONFIRM_TREASURY_ITEM_PRODUCT,
	payload
})

export const confirmTreasuryItemProductSuccess = (
	payload: IResponseResult
): IConfirmTreasuryItemProductSuccessAction => ({
	type: IndividualTreasuryItemActions.CONFIRM_TREASURY_ITEM_PRODUCT_SUCCESS,
	payload
})
